import { useEffect } from "react";
import { getRequestDemoData } from "../../store/slices/DemoSlice";
import { connect } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import { logDemoUsageDataAsync } from "../../store/slices/DemoSlice";
import { DemoUsageLogRequest } from "../../interfaces/request/DemoUsageLogRequest";
import { DemoUsageType } from "../../shared/enums/DemoUsageTypeEnum";
import ViewExamplesDescription from "./ViewExamples/ViewExamplesDescription";

interface Props {
  dispatch: AppDispatch;
  selectedProductId: number;
  demoExampleData: any[];
}

export function ViewExamples(props: Props) {
  const { demoExampleData, selectedProductId, dispatch } = props;

  useEffect(() => {
    if (demoExampleData.length === 0 && selectedProductId) {
      dispatch(getRequestDemoData(selectedProductId));
    }
  }, [demoExampleData.length, selectedProductId, dispatch]);

  const logDownload = (demoId: string, usageType: DemoUsageType) => {
    const logRequest: DemoUsageLogRequest = {
      DemoId: demoId,
      UsageType: usageType,
    };
    dispatch(logDemoUsageDataAsync(logRequest));
  };

  return (
    <div className="px-8 font-inter text-base">
      <ViewExamplesDescription logDownload={logDownload} />
    </div>
  );
}

const mapStateToProps = (state: RootState, props: any) => {
  return {
    demoExampleData: state.demoData.demoExampleData,
    selectedProductId: state.productData.selectedProductId,
    ...props,
  };
};

export default connect(mapStateToProps)(ViewExamples);
